
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect } from "react";
import { authKey, GET_SCHEDULE_NO_LIST, GET_WEEKLY_SCHEDULE_PLAN_BY_SCHEDULE_NO, GET_STAKEHOLDER_CATEGORY, PRINT_DOWNLOAD_DATA, APPROVE_STAKEHOLDER_SCHEDULE } from '../../../common/URLs';

import jwt from 'jwt-decode';
import DatePicker from "react-datepicker";
import { DataGrid } from '@mui/x-data-grid';
import { Button, Box, Container, Card, TextField, FormControl, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, CardContent, Grid, InputLabel, Select, Tooltip } from '@mui/material'
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import moment from 'moment';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from '../../../common/constants';
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ClearSearchIcon, ViewIcon } from '../../../common/icons';
import apiClient from '../../../axios';

function ScheduleHarvestingDetails(props) {

  const navigate = useNavigate();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const location = useLocation();

  const [searchVisible, setSearchvisible] = useState(false);
  const [scheduleno, setScheduleno] = useState([]);
  const [weeklyscheduledata, setWeeklyscheduledata] = useState([]);
  const [stakeholderType, setStakeholderType] = useState("");
  //const[stakeholderURN,setStakeholderURN]= useState("");
  const [stakeholderDetails, setStakeholderDetails] = useState();
  const [hideHarvesting, setHideHarvesting] = useState();
  const [selectedUrn, setSelectedUrn] = useState();
  const [selectedRows, setSelectedRows] = useState();
  //const [selectedType, setSelectedType] = useState();
  //const [plantconsumptiondate, setPlantconsumptiondate] = React.useState(new Date());
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date(fromDate.getTime() + 7 * 24 * 60 * 60 * 1000));
  const [printHarvestingInstruction, setPrintHarvestingInstruction] = useState();

  const [approveButtonData, setApproveButtonData] = useState();
  const [approveDataList, setApproveDataList] = useState();

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => setLogModalOpen2(false);

  const [searchFilter, setSearchFilter] = useState({
    "weeklyScheduleNumber": "",
    "pickUpFromDate": null,
    "pickUpToDate": null,
  });

  const harvestingDetails = (cellValues) => {

    navigate('./harvestingDetails', {
      state: { selectedRow: cellValues.row }
    });
  }
  //   useEffect(() => {
  //     setSelectedUrn(location?.state?.data);
  //   }, []);

  useEffect(() => {
    if (scheduleno && scheduleno.length > 0)
      getWeeklySchedule(scheduleno[0]);
  }, [scheduleno])

  //   useEffect(() => {
  //     if (selectedUrn?.urn ? selectedUrn?.urn : decoded.extension_URN) {
  //       getStakeDetails();
  //     }
  //   }, [selectedUrn?.urn ? selectedUrn?.urn : decoded.extension_URN]);

  //   function getStakeDetails() {
  //     loaderService.showLoader()
  //     apiClient
  //       .post(GET_STAKEHOLDER_CATEGORY,
  //         {
  //           "urn": selectedUrn?.urn ? selectedUrn?.urn : decoded.extension_URN,
  //           "type": ""
  //         },
  //         {
  //           headers: {
  //             Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
  //           }
  //         }, null
  //       )
  //       .then((response) => {
  //         setStakeholderDetails(response.data);
  //         //getWeeklySchedule(null, scheduleno[0]);
  //         getScheduleNo();
  //         loaderService.hideLoader()
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //         loaderService.hideLoader()
  //         toast.error(error.message);
  //       });
  //   }

  useEffect(() => {
    getScheduleNo();
  }, []);


  const getScheduleNo = () => {
    loaderService.showLoader()
    apiClient
      .post(GET_SCHEDULE_NO_LIST,
        {
          //"stakeholderUrn": selectedUrn?.urn ? selectedUrn?.urn : decoded.extension_URN,
          "stakeholderType": "HIT"
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setScheduleno(response.data.scheduleNoList);
        //getWeeklySchedule({ target: { value: response.data.scheduleNoList[0] } });
        setSearchFilter({ "weeklyScheduleNumber": response.data.scheduleNoList[0] })
        loaderService.hideLoader();
      })
      .catch(function (error) {
        // console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getWeeklySchedule = (serachvalue) => {

    // let weeklyScheduleNo = e?.target?.value;
    // if (weeklyScheduleNo) { setSearchFilter({ "weeklyScheduleNumber": weeklyScheduleNo }) }
    loaderService.showLoader();
    apiClient
      .post(GET_WEEKLY_SCHEDULE_PLAN_BY_SCHEDULE_NO,
        {
          "weeklyScheduleNumber": serachvalue ? serachvalue : null,
          //"stakeholderUrn": selectedUrn?.urn ? selectedUrn?.urn : decoded.extension_URN,
          "stakeholderType": "HIT",
          //   "activityType": location?.state?.data?.activityTypeLoad,
          //   "pickUpFromDate": (stakeholderDetails?.category === "HIT" || stakeholderDetails?.category === "Transporter" ) ? null : fromDate,
          //   "pickUpToDate": (stakeholderDetails?.category === "HIT" || stakeholderDetails?.category === "Transporter") ? null : toDate

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setWeeklyscheduledata(response.data.weeklySchedulePlanDetailsList);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });

  }
  const handleChange = (e) => {
    if (e.target.name === "weeklyScheduleNumber") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
    }
  }

  function searchScheduleDetails(e) {
    e.preventDefault();
    getWeeklySchedule(searchFilter.weeklyScheduleNumber);
  }

  const columns = [
    { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
    { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 150 },
    {
      field: 'schedulePickupDate', headerName: 'Pick up Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'scheduleRbCbQuantity', headerName: 'Quantity (in MT)', width: 150 },
    {
      field: 'firstPartyUrn', headerName: 'URN(1stParty)', width: 150,
      renderCell: (cellValues) => {
        return (
          stakeholderDetails?.category === "Grower" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.firstPartyUrn}</>
            :
            <> {cellValues?.row?.firstPartyUrn} </>
        );
      }
    },
    {
      field: 'firstPartyContactNo', headerName: 'Contact Details(1stParty)', width: 150,
      renderCell: (cellValues) => {
        return (
          stakeholderDetails?.category === "Grower" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.firstPartyContactNo}</>
            :
            <> {cellValues?.row?.firstPartyContactNo} </>
        );
      }
    },
    {
      field: 'firstPartyLocationName', headerName: 'Location(1stParty)', width: 150,
      renderCell: (cellValues) => {
        return (
          stakeholderDetails?.category === "Grower" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.firstPartyLocationName}</>
            :
            <> {cellValues?.row?.firstPartyLocationName} </>
        );
      }
    },
    { field: 'secondPartyUrn', headerName: 'URN(2ndParty)', width: 150 },
    { field: 'secondPartyContactNo', headerName: 'Contact Details(2ndParty)', width: 150 },
    { field: 'secondPartyLocationName', headerName: 'Location(2ndParty)', width: 150 },
    {
      field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
    { field: 'poStpoNumber', headerName: 'PO Number', width: 150 },
    { field: 'landId', headerName: 'Land ID', width: 150 },
    { field: 'inventoryType', headerName: 'Type of Inventory', width: 150 },

    {
      field: 'isScheduledApproved', headerName: 'Approval Status', width: 150,
      valueFormatter: (params) => {
        if (params.value === true) {
          return 'Approved';
        }
        else if (params.value === false) {
          return 'Not Approved';
        }
        else {
          return '';
        }
      },
    },
    {
      field: 'Navigate', headerName: "Action", width: 200,
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Harvesting Details">
          <IconButton
            color="primary"
            onClick={() => harvestingDetails(cellValues)}
          >
            <ViewIcon />
          </IconButton>
          </Tooltip>
        );
      }
    },

  ];

  const printHarvestInstructions = (action, cellValues) => {
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": cellValues?.row?.id,
          "printDetailsType": "weekly_schedule",
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setPrintHarvestingInstruction(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }
  const onApprove = (e) => {
    onApproveButtonClick(true);
  }

  const onReject = (e) => {
    onApproveButtonClick(false);
  }

  const handleDateChange = (e) => {
    setSearchFilter({ ...searchFilter, "grnDate": e.format("YYYY-MM-DD") })
  }

  const onApproveButtonClick = (approval) => {
    loaderService.showLoader();
    let data = selectedRows.map(selectedRow => {
      return {
        "stakeholderType": selectedRow.stakeholderType,
        "weeklyScheduleNumber": selectedRow.weeklyScheduleNumber,
        "scheduleLineNumber": selectedRow.scheduleLineNumber
      }
    })
    apiClient
      .post(
        APPROVE_STAKEHOLDER_SCHEDULE,
        {
          "lstStakeholderWeeklyScheduleApproveDTO": [
            ...data
          ],
          "isApproved": approval
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token')
          }
        },
        null
      )
      .then((response) => {
        setApproveButtonData(response.data);
        getWeeklySchedule(searchFilter?.weeklyScheduleNumber);
        loaderService.hideLoader();

      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  useEffect(() => {
    if (approveButtonData) {
      if (approveButtonData.isSuccess === true) {
        handleLogModalOpen2();
      } else {
        handleLogModalOpen();
      }
    }
  }, [approveButtonData]);

  const clearSearch = (e) => {
    e.preventDefault();
    setSearchFilter({
      "weeklyScheduleNumber": "",
    })
    getWeeklySchedule(null);
  }

  const onWeeklyScheduleChange = (e) => {
    e.preventDefault();
    setSearchFilter({
      "weeklyScheduleNumber": e.target.value,
    })
    getWeeklySchedule(e.target.value);
  }

  return (
    <>
      <Container maxWidth="xxl">

        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT01</p>}
        <Typography variant="h5" gutterBottom>
          Weekly Pick-Up Plan
        </Typography>
        <Card>
          <CardContent>
            <Grid container spacing={2} direction="row">
              {stakeholderDetails?.category === "Grower" || stakeholderDetails?.category === "LLE" ?
                <>
                  {/* <Grid item xs={12} lg={4}>
              <FormControl fullWidth >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Scheduled from"
                      inputFormat="DD/MM/YYYY"
                      name="pickUpFromDate"
                      value={searchFilter.grnDate}
                      onChange={(e) => { handleDateChange(e) }}
                      renderInput={(params) => <TextField size="small" {...params} />}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid> */}
                  <p>Scheduled From</p>
                  <DatePicker className='dateField'
                    placeholderText="Scheduled from"
                    selected={fromDate}
                    dateFormat="dd/MM/yyyy"
                    name="pickUpFromDate"
                    onChange={date => setFromDate(date)}
                  />
                  <p>Scheduled To</p>
                  <DatePicker className='dateField'
                    placeholderText="Scheduled to"
                    selected={toDate}
                    dateFormat="dd/MM/yyyy"
                    name="pickUpToDate"
                    onChange={date => setToDate(date)}
                  />
                </> :
                <>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size='small'>
                      <InputLabel>Schedule Number</InputLabel>
                      <Select label='Schedule Number' value={searchFilter?.weeklyScheduleNumber} onChange={(e) => onWeeklyScheduleChange(e)}>
                        <MenuItem >Select</MenuItem>
                        {scheduleno.map(
                          (schNo, index) => {
                            return <MenuItem value={schNo}>{schNo}</MenuItem>
                          }
                        )
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={2}>
                    <Button startIcon={<ClearSearchIcon />} variant="contained" sx={{ minWidth: 100 }} color="primary" onClick={(e) => clearSearch(e)}>
                      Clear
                    </Button>
                  </Grid>

                  {/* {searchVisible &&
                    <>
                      <Grid item xs={12} lg={4}>
                        <TextField fullWidth size='small' type="text" label='Search' name="weeklyScheduleNumber" value={searchFilter.weeklyScheduleNumber} onChange={(e) => handleChange(e)} />
                      </Grid>
                      <Grid item xs={12} lg={2}>
                        <Button variant="contained" color="primary" onClick={(e) => searchScheduleDetails(e)}>
                         Search
                        </Button>
                      </Grid>
                    </>
                  } */}
                </>
              }
            </Grid>
            <Box style={{ height: 450, width: '100%', marginTop: '2vh' }}>
              {
                weeklyscheduledata &&
                <DataGrid rows={weeklyscheduledata}
                  columns={columns}
                  pageSize={5}
                  components={{ Toolbar: QuickSearchToolbar }}
                />
              }
            </Box>
          </CardContent>
        </Card>
      </Container>
    </>
  )
}
export default ScheduleHarvestingDetails;